import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-314600a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "primary-menu" }
const _hoisted_2 = { class: "icons" }
const _hoisted_3 = ["id", "href", "onClick", "onMouseover", "onMouseleave"]
const _hoisted_4 = { class: "icons icon-setting icons-bottom" }
const _hoisted_5 = ["onClick", "onMouseleave"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_popover = _resolveComponent("b-popover")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.icons, (icon, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          (_openBlock(), _createElementBlock("a", {
            id: `${icon.id}`,
            key: `${icon.id}`,
            href: 
            index === 2 && _ctx.latestChecklistId
              ? `${icon.url}?checklistId=${_ctx.latestChecklistId}`
              : icon.url
          ,
            class: _normalizeClass(`icon-wrapper ${
            index >= _ctx.numberItemTop ? 'icon-hidden border-icons' : ''
          } ${_ctx.hoverMenuIndex === index ? 'active-hover' : ''}`),
            onClick: (e) => _ctx.selectIcon(e, index, icon),
            onMouseover: ($event: any) => (_ctx.selectIconOnHover(index)),
            onMouseleave: ($event: any) => (_ctx.unHoveredIcon(index))
          }, [
            (index !== 3)
              ? (_openBlock(), _createBlock(_resolveDynamicComponent(icon.icon), {
                  key: 0,
                  class: _normalizeClass(`${icon.isSmall ? 'icon-small' : 'icon'} ${
              _ctx.selectedIconIndex === index ? 'active' : ''
            } ${_ctx.hoverMenuIndex === index ? 'active-hover' : ''} ${
              index >= _ctx.numberItemTop ? 'md:tw-hidden' : ''
            }`),
                  alt: icon.alt
                }, null, 8, ["class", "alt"]))
              : (_openBlock(), _createBlock(_resolveDynamicComponent(icon.icon), {
                  key: 1,
                  class: _normalizeClass(`click-none !tw-filter-none ${
              icon.isSmall ? 'icon-small' : 'icon'
            } ${_ctx.selectedIconIndex === index ? 'active ' : ''} ${
              index >= _ctx.numberItemTop ? 'md:tw-hidden' : ''
            }`),
                  alt: icon.alt,
                  color: `${
              _ctx.selectedIconIndex === 3 || _ctx.iconHover ? '#387DFF' : '#211F58'
            }`,
                  onMouseover: _cache[0] || (_cache[0] = ($event: any) => (_ctx.iconHover = true)),
                  onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_ctx.iconHover = false))
                }, null, 40, ["class", "alt", "color"]))
          ], 42, _hoisted_3)),
          (index !== _ctx.hoverMenuIndex || !_ctx.isMenuOpen)
            ? (_openBlock(), _createBlock(_component_b_popover, {
                key: 0,
                target: `${icon.id}`,
                triggers: "hover",
                placement: "right",
                "custom-class": "custom-actions-popover",
                offset: 5,
                delay: {
            show: 0,
            hide: 100,
          },
                onShow: ($event: any) => (true)
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, _toDisplayString(icon.sectionTitle), 1)
                ]),
                _: 2
              }, 1032, ["target"]))
            : _createCommentVNode("", true)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.iconGroupBottom, (icon, index) => {
        return (_openBlock(), _createElementBlock("span", {
          key: index,
          class: "icon-wrapper border-icons",
          onClick: () => _ctx.selectIcon(index + _ctx.numberItemTop),
          onMouseover: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.selectIconOnHover && _ctx.selectIconOnHover(...args))),
          onMouseleave: ($event: any) => (_ctx.unHoveredIcon(index + _ctx.numberItemTop))
        }, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(icon.icon), {
            class: _normalizeClass(`${icon.isSmall ? 'icon-small' : 'icon'} ${
            _ctx.selectedIconIndex === index + _ctx.numberItemTop ? 'active' : ''
          }`),
            alt: icon.alt
          }, null, 8, ["class", "alt"]))
        ], 40, _hoisted_5))
      }), 128))
    ])
  ]))
}